import EsgDailyEmail from './EsgDailyEmail'

export default EsgDailyEmail
